import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerByOid } from '../../services/Ebootis.Queries/CustomerByOid';
import { CustomerSearch } from '../../services/Ebootis.Queries/CustomerSearch';
import { HierarchyNodes } from '../../services/Ebootis.Queries/HierarchyNodes';
import { IZbsApp } from '../../services/Ebootis.ServiceProxies/IZbsApp';

@Injectable({
	providedIn: 'root'
})
export class CustomerService {

	constructor(
		private m_customerSearch: CustomerSearch,
		private m_zbsApp: IZbsApp,
		private m_hierarchyNodes: HierarchyNodes,
		private m_customerByOid: CustomerByOid
	) { }

	/**
	 * Liefert das Ergebnis des Queries für CustomerSearch zurück.
	 * @param p_params Parameter für CustomerSearch
	 */
	public searchCustomer(p_params: CustomerSearch.Params): Observable<CustomerSearch.Customer[]> {
		return this.m_customerSearch.query(p_params).pipe(map((obj) => obj.customers));
	}

	/**
	 * Liefert das Ergebnis der ServiceMethode für saveCustomer zurück.
	 * @param p_customer IZbsApp.Customer
	 */
	public saveCustomer(p_customer: IZbsApp.Customer, p_cfgOid: string): Observable<any> {
		return this.m_zbsApp.saveCustomer(p_customer, p_cfgOid);
	}

	/**
	 * Liefert das Ergebnis der ServiceMethode für removeCustomer zurück.
	 * @param p_customer IZbsApp.Customer
	 */
	public removeCustomer(p_customer: IZbsApp.Customer, p_cfgOid: string): Observable<any> {
		return this.m_zbsApp.removeCustomer(p_customer.oid, p_cfgOid);
	}

	/**
	 * Liefert das Ergebnis des Queries für HierarchyNodes zurück.
	 * @param p_params Parameter für HierarchyNodes
	 */
	public searchHierarchyNodes(p_params: HierarchyNodes.Params): Observable<string[]> {
		return this.m_hierarchyNodes.query(p_params);
	}

	/**
	 * Liefert das Ergebnis des Queries für CustomerByOid zurück.
	 * @param p_params Paramter für CustomerByOid
	 */
	public searchCustomerByOid(p_params: CustomerByOid.Params): Observable<CustomerByOid.Result> {
		return this.m_customerByOid.query(p_params);
	}
}
